import { arrayToObject } from '@hotglue/common';

const defaultState = {
  supported: {},
  linked: undefined,
  linkedList: [],
  selectedTarget: undefined,
};

export default (state = defaultState, action) => {
  let newState = Object.assign({}, state);
  const { payload, status, type, params } = action;

  switch (type) {
    case 'SET_TENANT':
    case 'CLEAR_TARGETS':
      newState.linked = undefined;
      return newState;

    case 'FETCH_SUPPORTED_TARGETS':
      const { flowId } = params
      if (status == 'success') newState.supported[flowId] = arrayToObject(payload, 'target');
      return newState;

    case 'FETCH_LINKED_TARGETS':
      if (status == 'success') {
        newState.linked = arrayToObject(payload, 'target');
        newState.linkedList = payload;
      }
      return newState;

    case 'ADD_LINKED_TARGET':
      if (status == 'success' && params.target) newState.linked = { [params.target.target]: params.target };
      return newState;

    case 'FETCH_LINKED_TARGET':
      if (status == 'success') {
        newState.linked = arrayToObject(payload, 'target');
        newState.linkedList = payload;
      }
      return newState;

    case 'SELECT_TARGET':
      newState.selectedTarget = payload;
      return newState;
  }

  return state;
};
